function getReadableTextColor(color) {
  const match = /^#([0-9a-f]{6})$/i.exec(color || "");
  if (!match) return "#374151";

  const value = match[1];
  const red = Number.parseInt(value.slice(0, 2), 16);
  const green = Number.parseInt(value.slice(2, 4), 16);
  const blue = Number.parseInt(value.slice(4, 6), 16);
  const luminance = (red * 299 + green * 587 + blue * 114) / 1000;
  return luminance > 155 ? "#1f2937" : "#ffffff";
}

export function RouteBadge({ color, name }) {
  if (!name) {
    return <span className="route-badge route-badge--unmapped">Belum dipetakan</span>;
  }

  const safeColor = /^#[0-9a-f]{6}$/i.test(color || "") ? color : null;
  const style = safeColor
    ? {
        backgroundColor: safeColor,
        color: getReadableTextColor(safeColor),
      }
    : undefined;

  return (
    <span
      className={`route-badge${safeColor ? "" : " route-badge--default"}`}
      style={style}
    >
      {name}
    </span>
  );
}
